import classes from './PriceTable.module.css';
import clsx from 'clsx';
import Button from 'Components/Atoms/Button/Button';
import { useTranslation } from 'react-i18next';
import { PricePlanTableIcons } from './PricePlanTableIcons';

const CONTACT_URL = 'https://demo.banktrack.com/meetings/banktrack/demo5';

const HIGHLIGHTS = [
    { iconName: 'config', titleKey: 'custom-limits', descriptionKey: 'custom-limits-description' },
    { iconName: 'societies', titleKey: 'multi-company', descriptionKey: 'multi-company-description' },
    { iconName: 'consolidation', titleKey: 'consolidation', descriptionKey: 'consolidation-description' },
    { iconName: 'invoices', titleKey: 'unlimited-billing', descriptionKey: 'unlimited-billing-description' },
    { iconName: 'integrations', titleKey: 'custom-integrations', descriptionKey: 'custom-integrations-description' },
    { iconName: 'support', titleKey: 'account-manager', descriptionKey: 'account-manager-description' },
];

export default function CardEnterprise() {
    const { t } = useTranslation('pricing');

    return (
        <div className={classes.planCard}>
            <div className={classes.planCardHeader}>
                <div className={classes.planCardContent}>
                    <div className={clsx(classes.planCardTitle, classes.gradientTextTertiary)}>
                        {t('business-premium.title')}
                    </div>

                    <div className={clsx(classes.priceSubtitle, 'text-gray-500')}>
                        {t('business-premium.description-slot-1')}{' '}
                        <strong className={classes.highlight}>{t('business-premium.description-slot-2')}</strong>{' '}
                        {t('business-premium.description-slot-3')}{' '}
                        <strong className={classes.highlight}>{t('business-premium.description-slot-4')}</strong>
                    </div>

                    <div className="pt-6">
                        <div className={classes.textLarge}>{t('business-premium.price')}</div>
                        <div className={classes.priceDescription} style={{ position: 'static', marginTop: 4 }}>
                            {t('business-premium.price-description')}
                        </div>
                    </div>
                </div>
            </div>

            <div className={classes.line} />

            <div className={classes.planCardContent}>
                <ul className={classes.list}>
                    <li>
                        <div className={classes.includesLabel}>
                            {t('business-premium.highlights.includes-advanced')}
                        </div>
                    </li>
                    {HIGHLIGHTS.map((item) => (
                        <li className="flex items-center gap-2" key={item.titleKey}>
                            <div className="flex-shrink-1">
                                <img
                                    src={PricePlanTableIcons[item.iconName].default}
                                    alt=""
                                    className={classes.featureIcon}
                                />
                            </div>
                            <div>
                                <div className={classes.itemTitle}>
                                    {t(`business-premium.highlights.${item.titleKey}`)}
                                </div>
                                <div className={classes.itemDescription}>
                                    {t(`business-premium.highlights.${item.descriptionKey}`)}
                                </div>
                            </div>
                        </li>
                    ))}
                </ul>
            </div>

            <div className={classes.planCardAction}>
                <Button target="_blank" className="w-full" rel="nofollow" href={CONTACT_URL}>
                    {t('enterprise.contact')}
                </Button>
            </div>
        </div>
    );
}
